module.exports = __webpack_public_path__ + "static/media/solution.c0e5be22.svg";